import type { PeriodeLektioner } from "@/interfaces/efteruddannelse";

export enum ReportStatus {
  HANDLED = "handled",
  EXPIRED = "expired",
  INSUFFICIENT = "insufficient",
  COMPLETED = "completed",
  TOO_LATE = "too_late",
}

export type CurrentPeriodReportSummary = {
  id: string;
  status: ReportStatus;
  uploaded_at: string | Date;
};

export type ReportingPeriod = {
  id: string;
  deadline: string | null;
  periodFromDate: string;
  periodToDate: string;
  periodToDateMinusOneDay: string;
  transferredToNextPeriod: number | null;
  transferredFromPreviousPeriod: number | null;
  reportedLessons: PeriodeLektioner | null;
  transferredFromPreviousLessons: PeriodeLektioner | null;
  transferredToNextLessons: PeriodeLektioner | null;
  hasBeenReported: boolean;
  hasOpenReport?: boolean;
  openReportId?: string | null;

  report: CurrentPeriodReportSummary | null;
};
